import { useIntl } from 'react-intl';
import { Alert, AlertDescription } from './ui/alert.tsx';
import { Button } from './ui/button.tsx';

export function PasskeyMergePrompt({
  error,
  isActing,
  onConfirm,
  onDecline,
}: {
  error: 'merge-conflict' | null;
  isActing: boolean;
  onConfirm: () => void;
  onDecline: () => void;
}) {
  const intl = useIntl();
  return (
    <Alert className="mt-4 grid gap-3">
      {error === 'merge-conflict' ? (
        <AlertDescription className="text-destructive">
          {intl.formatMessage({ id: 'web.auth.mergeConflict' })}
        </AlertDescription>
      ) : null}
      {error === null ? (
        <>
          <h2>{intl.formatMessage({ id: 'web.auth.passkeyMergeTitle' })}</h2>
          <p>
            {intl.formatMessage({ id: 'web.auth.passkeyMergeDescription' })}
          </p>
          <div className="flex flex-wrap gap-3">
            <Button
              className="min-h-11 font-semibold"
              variant="default"
              disabled={isActing}
              onClick={onConfirm}
              type="button"
            >
              {intl.formatMessage({ id: 'web.auth.passkeyMergeConfirm' })}
            </Button>
            <Button
              className="min-h-11 font-semibold"
              variant="secondary"
              disabled={isActing}
              onClick={onDecline}
              type="button"
            >
              {intl.formatMessage({ id: 'web.auth.passkeyMergeDecline' })}
            </Button>
          </div>
        </>
      ) : (
        <div className="flex flex-wrap gap-3">
          <Button
            className="min-h-11 font-semibold"
            variant="secondary"
            disabled={isActing}
            onClick={onDecline}
            type="button"
          >
            {intl.formatMessage({ id: 'web.auth.passkeyMergeDecline' })}
          </Button>
        </div>
      )}
    </Alert>
  );
}
